module.exports = __webpack_public_path__ + "img/k-rock.dbec9fee.png";